import { isString } from 'lodash-es';

type Settings = {
  zIndex: number | string;
  modalRootContainer?: Element;
};
export function getTooltipSettings(
  { zIndex, modalRootContainer }: Settings,
) {
  const numberZIndex = isString(zIndex)
    ? parseInt(zIndex, 10)
    : zIndex;
  return {
    zIndex: numberZIndex + 1,
    container: modalRootContainer ?? 'body',
  };
}
